export const Location = ({mapFocus, setMapFocus}) => {
 return <div style={{display: 'inline-block'}}> 
<label for="mapLocation">Location:</label>
<select name="mapLocation" id="mapLocation" value={mapFocus} onChange={(e) => setMapFocus(e.target.value)} >
    <option value="world">World</option>
    <option value="pacificRim">Pacific Rim</option>
    <option value="northAmerica">North America</option>
    <option value="southAmerica">South America</option>
    <option value="europe">Europe</option>
    <option value="asia">Asia</option>
    <option value="africa">Africa</option>
    <option value="australia">Australia</option>
</select>
 </div>
}